/* @flow */
/** @jsx h */
import { h } from 'preact';
import { checkIsTablet } from '../js/platform';

type PropsType = {
  onTouchStart?: (e: TouchEvent) => void;
  onClick?: (e: MouseEvent) => void;
  children: h.JSX.Element | string;
  debug?: boolean;
  canIncreaseAreaForTablet?: boolean;
  extraClickableZone?: number;
};

export function ClickArea({
  onTouchStart = () => {},
  onClick = () => {},
  debug = false,
  canIncreaseAreaForTablet = true,
  extraClickableZone = 0,
  children
}: PropsType) {
  const debugStyles = {
    background: 'rgba(0, 0, 255, 0.5)',
    boxShadow: 'inset 0 0 0 1px rgb(0, 0, 255)'
  };

  const style: {
    container: h.JSX.CSSProperties;
    clickableArea: h.JSX.CSSProperties;
  } = {
    container: {
      position: 'relative'
    },
    clickableArea: {
      ...(debug ? debugStyles : {}),
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      right: 0,
      pointerEvents: 'auto'
    }
  };

  if (canIncreaseAreaForTablet && checkIsTablet()) {
    style.clickableArea = {
      ...(debug ? debugStyles : {}),
      position: 'absolute',
      left: '-20px',
      right: '-20px',
      bottom: '-20px',
      top: '-20px'
    };
  } else if (extraClickableZone) {
    style.clickableArea = {
      ...(debug ? debugStyles : {}),
      position: 'absolute',
      left: '-' + extraClickableZone + 'px',
      right: '-' + extraClickableZone + 'px',
      bottom: '-' + extraClickableZone + 'px',
      top: '-' + extraClickableZone + 'px'
    };
  }

  return (
    <div style={style.container}>
      <div
        className={'clickable-area'}
        onClick={e => onClick(e)}
        onTouchStart={onTouchStart}
        style={style.clickableArea}
      />
      {children}
    </div>
  );
}
